export default {
  setNotAccomplishNum(state, data) {
    state.notAccomplishNum = data
  }
}
